<template>
  <div class="app-bar">
    <router-link v-if="currentUser" :to="`/account/${this.currentUser.displayName}`">
      <svg style="width:40px;height:40px; border: 2px solid #99FF99; border-radius: 10px; padding: 3px" viewBox="0 0 24 24">
        <path
          fill="#99FF99"
          d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"
        />
      </svg>
    </router-link>
    <router-link to="/">
      <img :src="oyen" alt="oyen.de" />
      <!-- <span style="padding: 4px 20px" v-else class="mx-text red--text">{{tag.name}}</span> -->
    </router-link>
    <router-link v-if="currentUser" to="/more">
      <svg style="width:40px;height:40px; border: 2px solid #99FF99; border-radius: 10px"  viewBox="0 0 24 24">
          <path fill="#99FF99" d="M21.47,4.35L20.13,3.79V12.82L22.56,6.96C22.97,5.94 22.5,4.77 21.47,4.35M1.97,8.05L6.93,20C7.24,20.77 7.97,21.24 8.74,21.26C9,21.26 9.27,21.21 9.53,21.1L16.9,18.05C17.65,17.74 18.11,17 18.13,16.26C18.14,16 18.09,15.71 18,15.45L13,3.5C12.71,2.73 11.97,2.26 11.19,2.25C10.93,2.25 10.67,2.31 10.42,2.4L3.06,5.45C2.04,5.87 1.55,7.04 1.97,8.05M18.12,4.25A2,2 0 0,0 16.12,2.25H14.67L18.12,10.59" />
      </svg>
    </router-link>
    <router-link v-if="currentUser" to="/add">
      <svg style="width:40px;height:40px; border: 2px solid #99FF99; border-radius: 10px" viewBox="0 0 24 24">
        <path fill="#99FF99" d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
      </svg>
    </router-link>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      oyen: require("@/assets/main.jpeg")
    };
  },
  computed: {
    ...mapState("user", ["currentUser"])
  },
  methods: {}
};
</script>

<style>
.app-bar {
  bottom: 0px;
  margin: 0;
  left: 0;
  z-index: 9999999;
  width: 100%;
  background: #000;
  align-items: center;
  height: 60px;
  position: fixed;
  display: flex;
  flex-direction: row;
  padding-top: 10px;
  padding-bottom: 60px;
  align-items: flex-start;
  justify-content: space-around;
}

.app-bar img {
  height: 44px;
  width: 44px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background-repeat: no-repeat;
  background-position: cover;
}

.xl-shadow {
  box-shadow: 0 1px 3px 0 rgba(50, 50, 93, 0.15),
    0 4px 6px 0 rgba(112, 157, 199, 0.15);
  /* box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04); */
}

.mx-text {
  height: 30px !important;
  width: 100px;
  text-transform: capitalize;
  padding: 3px 8px;
}

@media screen and (min-width: 1000px) {
  .app-bar {
    width: 41%;
    margin: 0 30%;
  }
}

@media screen and (min-width: 100px) and (max-width: 1300px) {
  .app-bar {
    width: 100%;
    margin: 0 0%;
  }
}

@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
  .app-bar {
    width: 100%;
    margin: 0%;
  }
}

@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1.5) {
  .app-bar {
    width: 100%;
    margin: 0%;
  }
}
</style>

